// import Http from './http'; // não precisa de .js
import firestore from "../firebase/firestore";
import axios from "axios";

const token = !localStorage.getItem("token")
  ? false
  : localStorage.getItem("token");
if (token) axios.defaults.headers.get["Authorization"] = "Bearer " + token;

const config = {
  headers: {
    Authorization: "Bearer " + token,
    "Access-Control-Allow-Origin": "*",
  },
};

export const getInvoice = (uid) => {
  return axios.get("/getInvoice/" + uid, config);
};

export const getInvoicesCompetence = (power_plant, competence) => {
  return axios.get(
    "/getInvoicesCompetence/" + power_plant + "/" + competence,
    config,
  );
};

export const getInvoiceCompetenceTotals = (power_plant, competence) => {
  return axios.get(
    "/getinvoiceCompetenceTotals/" + power_plant + "/" + competence,
    config,
  );
};

export const getInvoices = (uid) => {
  return axios.get("/getInvoices/" + uid, config);
};

export const addInvoice = (uid, invoice) =>
  axios.post("/addInvoice/" + uid, invoice, config);

export const addInvoiceTotal = (power_plant, competence, total_invoice) =>
  axios.post(
    "/addInvoiceTotal/" + power_plant + "/" + competence,
    total_invoice,
    config,
  );

export const updateInvoiceTotal = async (power_plant, competence, data) => {
  const totalBillingId = power_plant + "-" + competence;
  const totalBillingRef = firestore
    .collection("TotalBilling")
    .doc(totalBillingId);
  const totalBillingCompetence = await totalBillingRef.get();
  if (totalBillingCompetence.exists) {
    return firestore
      .collection("TotalBilling")
      .doc(totalBillingId)
      .update(data);
  } else {
    throw "Essa competência não existe.";
  }
};

export const updateInvoice = (uid, invoice) =>
  axios.put("/updateInvoice/" + uid, invoice, config);
